import { get as getGame } from '../reducers/gameReducer';


export const createGameAction = (game) => {
    return (dispatch, getState, { getFirestore }) => {
        const firestore = getFirestore()
        firestore.collection('games').add({
            ...game
        }).then(() => {
            dispatch({ type: 'CREATE_GAME', game })
        }).catch((err) => {
            dispatch({ type: 'CREATE_GAME_ERROR', err })
        })
    }
}

export const deleteGameAction = (game) => {
    return (dispatch, getState, { getFirestore }) => {
        const firestore = getFirestore()
        firestore.collection('games').doc(game.id).delete().then(function() {
            console.log("game successfully deleted!");
        }).catch(function(error) {
            console.error("Error removing game: ", error);
        });
    }
}

export const updateGameAction = (updatedGame) => {
    console.log(updatedGame.approved);

    const id = updatedGame.id;
    delete updatedGame.id;
    return (dispatch, getState, { getFirestore }) => {
        const firestore = getFirestore()
        firestore.collection('games').doc(id).update({
            ...updatedGame
        });
    }
}

export const getGameAction = (id) => {
    return (dispatch, getState, { getFirestore }) => {
        const firestore = getFirestore()
        firestore.collection('games').doc(id).get().then((doc) => {
            if (doc.exists) {
                const data = doc.data()
                data.id = id;
                dispatch(getGame(data));
            } else {
                console.log('does not exist')
            }

        })
    }
}

export const clearGameAction = () => {
    return (dispatch) => {
        dispatch(getGame({}));
    }
}


const prepareReasons = (list) => {
    let arr = [];
    list.forEach(function (value) {
        arr.push({
            R: value
        });
    });
    return arr;
}

const prepareStatements = (list) => {
    let arr = [];
    list.forEach(function (value) {
        arr.push({
            S: value
        });
    });
    return arr;
}

const shapePlayer = (playerForm) => {
    return {
        name: playerForm.name,
        image: playerForm.image,
        details: {
            Name: playerForm.name,
            HR: prepareReasons(playerForm.HR),
            SR: prepareReasons(playerForm.SR),
            HS: prepareStatements(playerForm.HS),
            SS: prepareStatements(playerForm.SS)

        }
    }
}


export const createPlayerAction = (playerForm) => {
    const id = playerForm.gameId;
    const player = shapePlayer(playerForm);
    return (dispatch, getState, { getFirestore }) => {
        const firestore = getFirestore()
        firestore.collection('games').doc(id).collection('players').add({
            ...player
        }).then(() => {
            dispatch({ type: 'CREATE_PLAYER', player: player })
        }).catch((err) => {
            dispatch({ type: 'CREATE_PLAYER_ERROR', err })
        })
    }
}

export const deletePlayerAction = (player) => {
    return (dispatch, getState, { getFirestore }) => {
        const firestore = getFirestore()
        firestore.collection('games').doc(player.gameId).collection('players').doc(player.id).delete().then(function() {
            console.log("player successfully deleted!");
        }).catch(function(error) {
            console.error("Error removing document: ", error);
        });;
    }
}

export const updatePlayerAction = (playerForm) => {
    const id = playerForm.id;
    const gameId = playerForm.gameId;
    const player = shapePlayer(playerForm);
    return (dispatch, getState, { getFirestore }) => {
        const firestore = getFirestore()
        firestore.collection('games').doc(gameId).collection('players').doc(id).update({
            ...player
        });
    }
}

export const getAPlayerAction = (playerId, id) => {
    return (dispatch, getState, { getFirestore }) => {
        const firestore = getFirestore()
        firestore.collection('games').doc(id).collection('players').doc(playerId).get().then((doc) => {
            if (doc.exists) {
                const data = doc.data()
                data.id = playerId;
                data.gameId = id;
                dispatch({ type: 'GET_PLAYER', data })
            } else {
                console.log('does not exist')
            }

        })
    }
}

export const clearPlayerAction = () => {
    return (dispatch) => {
        dispatch({ type: 'GET_PLAYER', data: {} })
    }
}

